import { render, staticRenderFns } from "./error_layout_generic.vue?vue&type=template&id=42797483"
import script from "./error_layout_generic.vue?vue&type=script&lang=js"
export * from "./error_layout_generic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Logo: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/Logo/Logo.vue').default})
